import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LuLock, LuX } from "react-icons/lu";

const DISMISSED_KEY = "kd_prompt_dismissed";

export default function WholesalePrompt() {
  const { user, loading } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISSED_KEY) === "true"
  );

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, "true");
    setDismissed(true);
  };

  if (loading || user || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 pointer-events-none">
      <div className="max-w-4xl mx-auto pointer-events-auto">
        <div className="bg-brand-navy border border-white/10 rounded-2xl shadow-2xl px-5 py-4 flex flex-col sm:flex-row items-center gap-4">
          <div className="w-10 h-10 rounded-xl bg-brand-amber/20 flex items-center justify-center flex-shrink-0">
            <LuLock size={18} className="text-brand-amber" />
          </div>

          <div className="flex-1 text-center sm:text-left">
            <p className="text-white font-bold text-sm">Wholesale pricing is exclusively for verified accounts</p>
            <p className="text-slate-400 text-xs mt-0.5">Sign in to view pricing, place orders, and access bulk discounts.</p>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <Link to="/register" className="text-xs font-bold text-slate-300 hover:text-white transition-colors px-3 py-2 rounded-lg hover:bg-white/10">
              Apply for Access
            </Link>
            <Link to="/login" className="bg-brand-amber hover:brightness-110 transition-all text-white font-bold text-xs px-4 py-2.5 rounded-xl">
              Sign In
            </Link>
            <button
              onClick={handleDismiss}
              className="w-7 h-7 rounded-lg flex items-center justify-center text-slate-500 hover:text-slate-300 hover:bg-white/10 transition-colors ml-1"
              aria-label="Dismiss"
            >
              <LuX size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
